import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import { Button, Card, Col } from 'reactstrap';
import AssetsGallery_Thin from '../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/AssetsGallery_Thin.svg'
import BackButton from "../../../../.././../../../designUtils/Logo/BackButton.svg"
import BrandDetails from './Components/BrandDetails';
import ProductDetails from './Components/ProductDetails';
import LoadingOverlay from 'react-loading-overlay';
import Loader from "react-loaders";
import FetchAllCategoryAndSubCategory from '../../../../../../../../Service/DashboardServices/AssetGalleryServices/FetchAllCategoryAndSubCategoryService';
import GoogleDriveAssetsImport from './Components/ImportedFiles/GoogleDriveAssetsImport';
import GoogleDriveAssetsDetails from './Components/ImportedFiles/GoogleDriveAssetsDetails';

function AssetGalleryMain(props) {
  const [category, setCategory] = useState()
  const [currentPage, setCurrentPage] = useState(props.UserPermission ? props.UserPermission.AssetGallery_Products ? 2 : props.UserPermission.AssetGallery_Brands ? 1 : '' : "")
  const [subCategory, setSubCategory] = useState()
  const [categoryID, setCategoryID] = useState(2)
  const [loadScreen, setLoadScreen] = useState(false)
  const [googleDriveLinkPopup, setGoogleDriveLinkPopup] = useState(false)
  const [importedRefreshKey, setImportedRefreshKey] = useState(0)

  useEffect(() => {
    setLoadScreen(true)
    let data = {
      integerId: props.storeOverview.integerID,
      assetIdentifier: ''
    };
    FetchAllCategoryAndSubCategory(props.token, data).then((response) => {
      if (response) {
        console.log(response);
        const filteredResponse = response.category.filter((item) => {
          const permitions = permitionsArray.find((perm) => (
            item.categoryName === perm.text && perm.value === true
          ))
          return permitions !== undefined
        })

        setCategory(filteredResponse)
        setSubCategory(response.subCategory)
        setLoadScreen(false)
      }
    });
  }, []);

  const permitionsArray = [
    {
      id: 1,
      text: "Brand",
      value: props.UserPermission ? props.UserPermission.AssetGallery_Brands : false
    },
    {
      id: 2,
      text: "Product",
      value: props.UserPermission ? props.UserPermission.AssetGallery_Products : false
    },
    {
      id: 3,
      text: "Imported Files",
      value: props.UserPermission ? props.UserPermission.AssetGallery_Products : false
    }
  ]

  return (
    <div className='ml-3'>
      <Card className='p-2 mb-2 child-card' >

        <Col md={12}>
          <h4>
            <button onClick={() => { props.goBackPA() }} className="hover-btn-link back-btn mr-1 mb-3 "  >
              <img src={BackButton} alt="not found" />
            </button>
            <img src={AssetsGallery_Thin} alt=' not found' />
            &nbsp; <b>Asset Gallery</b></h4>
          <hr className='line'></hr>
        </Col>
        <Col md={12}>
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <div className='d-flex'>
              {
                category && category.map((cat) => (
                  <h5
                    key={cat.id}
                    className={`ml-2 ${cat.id === categoryID ? 'selected-tab-assets-tab ' : 'assets-tab-not-selected'} `}
                    onClick={() => { setCurrentPage(cat.id); setCategoryID(cat.id) }}
                  >
                    <span className="d-flex align-items-center">
                      <b>{cat.categoryName}</b>
                      {cat.id === 1 && props.storeOverview.AssetDetailsStats.brandAssets !== 0 && (
                        <span className="assets-category-count">
                          {props.storeOverview.AssetDetailsStats.brandAssets}
                        </span>
                      )}

                      {cat.id === 2 && props.storeOverview.AssetDetailsStats.productAssets !== 0 && (
                        <span className="assets-category-count">
                          {props.storeOverview.AssetDetailsStats.productAssets}
                        </span>
                      )}

                      {cat.id === 3 && Number(props.storeOverview.AssetDetailsStats.importedAssets || 0) > 0 && (
                        <span className="assets-category-count">
                          {props.storeOverview.AssetDetailsStats.importedAssets}
                        </span>
                      )}
                    </span>
                  </h5>
                ))
              }
            </div>
            <Button
              color="primary"
              className="mb-2"
              onClick={() => setGoogleDriveLinkPopup(true)}
            >
              Import
            </Button>
          </div>
        </Col>
      </Card>
      <LoadingOverlay
        active={loadScreen}
        styles={{
          overlay: (base) => ({
            ...base,
            background: '#f1f4f6',
            opacity: 1,
          }),
          content: (base) => ({
            ...base,
            color: '#000',
          }),
        }}
        spinner={<Loader active type="ball-pulse" />}
        text="Loading asset details..."
      >

        {currentPage === 1 && <BrandDetails subCategory={subCategory} catId={categoryID} />}
        {currentPage === 2 && <ProductDetails subCategory={subCategory} catId={categoryID} />}
        {currentPage === 3 && (
          <GoogleDriveAssetsDetails
            subCategory={subCategory}
            catId={categoryID}
            refreshKey={importedRefreshKey}
          />
        )}
      </LoadingOverlay>

      <GoogleDriveAssetsImport
        token={props.token}
        isLinkPopupOpen={googleDriveLinkPopup}
        setIsLinkPopupOpen={setGoogleDriveLinkPopup}
        integerId={props.storeOverview.integerID}
        onImportSuccess={() => {
          setCurrentPage(3);
          setCategoryID(3);
          setImportedRefreshKey((prev) => prev + 1);
        }}
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    newUser: state.loggedUser.newUser,
    needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
    user: state.LWA.user,
    isAuth: state.LWA.isAuth,
    enableMobileMenu: state.theme.enableMobileMenu,
    enableClosedSidebar: state.theme.enableClosedSidebar,
    storeOverview: state.accountOverview.store.storeOverview,
    UserPermission: state.accountOverview.store.StoreUserPermission,
  };
};

export default connect(mapStateToProps)(AssetGalleryMain);
